import { withInstall } from "@xplus/utils/with-install";
import tabs from "./src/tabs.vue";
export const xTabs = withInstall(tabs);
export default xTabs;
export * from "./src/tabs";
